export type Params = {
    changeRequestId: number,
};

export const createEventReviewRoutePath = (params: Params) => {
    return `/events/review/${params.changeRequestId}`;
};
